<template>
  <div class="canvas-container">
    <canvas
      v-drag
      ref="timeAxis"
      class="time-canvas"
      :style="{ width: axisWidth + 'px' }"
    ></canvas>
  </div>
</template>
<script>
import { formatDuration } from '@/utils/smartCreation'
export default {
  props: {
    width: {
      type: Number,
      default: 0
    },
    duration: {
      type: Number,
      default: 0
    },
    scale: {
      type: Number,
      default: 10
    }
  },
  directives: {
    drag: function (e, bingding, vnode) {
      let canvas = e
      canvas.onmousedown = (e) => {
        if (vnode.context.duration === 0) {
          return false
        }
        const distanceX = e.clientX - e.offsetX
        vnode.context.changePointer(e.offsetX)
        document.onmousemove = (e) => {
          // 清除浏览器默认行为
          e.preventDefault()
          const moveX = e.clientX - distanceX
          vnode.context.changePointer(moveX)
        }
        document.onmouseup = (e) => {
          document.onmousemove = null
          document.onmouseup = null
        }
      }
    }
  },
  data() {
    return {
      axis: undefined,
      axisCtx: undefined,
      axisWidth: 6000,
      height: 25,
      that: this
    }
  },
  watch: {
    width: function (val) {
      if (val > 6000) {
        this.axisWidth = val
      } else {
        this.axisWidth = 6000
      }
      this.drawAxis()
    }
  },
  methods: {
    drawAxis() {
      const width = this.scale
      const top = this.height / 2
      const height = this.height
      const duration = this.axisWidth
      const scale = this.scale
      let canvas = this.axis
      let ctx = this.axisCtx
      let time = 1

      canvas.width = this.axisWidth
      canvas.height = this.height
      ctx.strokeStyle = '#666'
      ctx.fillStyle = '#666'
      ctx.font = '12px Source Han Sans CN'
      ctx.lineWidth = 0.4
      ctx.beginPath()
      ctx.moveTo(0, top)
      ctx.lineTo(0, height)
      ctx.fillText('00:00:00', -1, 10)
      ctx.closePath()
      ctx.stroke()
      ctx.translate(0.5, 0.5)
      while (duration >= time) {
        ctx.beginPath()
        if (time % scale === 0) {
          // 长线和时间; +1是为了让指针、刻度以及trackCurrentTime同步
          ctx.moveTo(width + 1, top)
          ctx.lineTo(width + 1, height)
          let text = formatDuration(time / 100)
          ctx.fillText(text, time * width / 100, 10)
        } else {
          // 短线
          ctx.moveTo(time * width + 1, height * 3 / 4)
          ctx.lineTo(time * width + 1, height)
        }
        ctx.closePath()
        ctx.stroke()
        time++
      }
    },
    changePointer(left) {
      let duration = left / this.scale
      if (duration < 0) duration = 0
      if (duration > this.duration) duration = this.duration
      this.$emit('move-by-axis', duration)
    }
  },
  mounted() {
    this.axis = this.$refs.timeAxis
    this.axisCtx = this.$refs.timeAxis.getContext('2d')
    this.drawAxis()
  }
}
</script>
<style lang="stylus" scoped>
.canvas-container
  width 100%
  height 30px
.time-canvas
  // position fixed
  // z-index 2
  height 25px
  background #FFFFFF
  border-bottom 1px solid #ccc
</style>
